import React from "react";
import "./ARStatusText.scss";
import ARTooltip from "../ARTooltip";
import {getStatusText, getToolTipInfo} from "./ARStatusText.model";
import ToolTipContent from "./ToolTipContent";
import {PATHS} from "../../route-dictionary";

const ARStatusText = ({pause_finish, is_paused, paused_by, is_enabled, is_up, state_effective_since, info}) => {
  const statusText = getStatusText({is_paused, is_enabled, is_up});
  const toolTipInfo = getToolTipInfo({info, is_enabled, is_up, is_paused, pause_finish, state_effective_since});

  const StatusTextName = <div
    className="ARStatusText"
    onClick={(e) => e.stopPropagation()}
    style={{backgroundColor: statusText.color}}
  >
    {statusText.name}
  </div>;

  const onMemberLinkClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    window.open(PATHS.MEMBERS.getDetailsIdPath(paused_by?.id));
  };

  const stopPropagation = (e) => {
    e.stopPropagation();
  };

  const onTooltipMount = () => {
    const memberLink = document.getElementById("member_link");
    memberLink?.addEventListener("click", onMemberLinkClick);

    const memberLinkSpan = document.getElementsByClassName("MemberLink");
    memberLinkSpan[0]?.addEventListener("click", stopPropagation);
  };

  const onTooltipHidden = () => {
    const memberLink = document.getElementById("member_link");
    memberLink?.removeEventListener("click", onMemberLinkClick);

    const memberLinkSpan = document.getElementsByClassName("MemberLink");
    memberLinkSpan[0]?.removeEventListener("click", stopPropagation);
  };

  return (
    toolTipInfo.display ?
      <ARTooltip
        content={<ToolTipContent toolTipInfo={toolTipInfo} paused_by={paused_by}/>}
        advancedOptions={{
          allowHTML: true,
          onMount: onTooltipMount,
          onUntrigger: onTooltipHidden
        }}
        interactive
      >
        {StatusTextName}
      </ARTooltip>
      :
      StatusTextName
  );
};

export default ARStatusText;